'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _CompanyGallery = require('./CompanyGallery.scss');var styles = _interopRequireWildcard(_CompanyGallery);
var _CompanySlider = require('./CompanySlider');var _CompanySlider2 = _interopRequireDefault(_CompanySlider);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // styles

var CompanyGallery = function CompanyGallery(props) {
  var renderSlide = function renderSlide(image, idx) {return (
      _react2.default.createElement('div', {
          key: image.thumbnail,
          'data-id': image.thumbnail,
          className: styles.slide,
          onClick: function onClick() {return props.openLightbox(idx);} },

        _react2.default.createElement('img', {
          src: image.thumbnail,
          alt: '' })));};




  return (
    _react2.default.createElement(_CompanySlider2.default, {
        wrapperWidth: props.wrapperWidth,
        isMobile: props.isMobile },

      props.images.map(renderSlide)));


};

CompanyGallery.propTypes = {
  images: _propTypes2.default.array,
  wrapperWidth: _propTypes2.default.number,
  openLightbox: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool };exports.default =


CompanyGallery;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyGallery/CompanyGallery.js
// module id = 2629
// module chunks = 0